
import { Vue, Options } from "vue-class-component";
import { Field, Form } from "vee-validate";
import * as yup from "yup";
import Store from "../../store";
import Router from "../../router";
import { AuthApi } from "../../autogen";
import FieldError from "../atoms/FieldError.vue";
import FormError from "../atoms/FormError.vue";
import ChangePassword from "../organisms/ChangePassword.vue";
import ActionButton from "../atoms/ActionButton.vue";

@Options({
  components: { Form, Field, FieldError, FormError, ChangePassword, ActionButton }
})
export default class Login extends Vue {
  globalErrors: { message: string }[] = [];
  resetPasswordParams = {};
  resetRequired = false;
  processing = false;
  inputLock = true;
  timerId = 0;
  async onSubmit(loginRequest: { username: string; password: string }) {
    this.processing = true;
    try {
      this.timerId = setInterval(() => {
        clearInterval(this.timerId);
        this.globalErrors = [{ message: "サーバーと通信出来ません。暫く経ってから再度お試しください。" }];
        this.processing = false;
      }, 10000);
      const storeInstance = Store.getInstance();
      const auth = await new AuthApi().login(loginRequest).then(auth => {
        storeInstance.setAuth(auth.data);
        return auth.data;
      });
      Router.push(`/clients/${auth.clientId}/departments/all/dashboard`);
    } catch (err) {
      if (err.response.status === 404 && err.response.data.error === "PasswordChangeRequired") {
        this.resetPasswordParams = {
          username: loginRequest.username,
          oldpassword: loginRequest.password
        };
        this.resetRequired = true;
      } else if (err.response.status === 404 && err.response.data.error === "Unauthorized") {
        this.globalErrors = [{ message: err.response.data.message }];
      } else if (err.response.status === 404 && err.response.data.error === "Locked") {
        this.globalErrors = [{ message: err.response.data.message }, { message: "暫く経ってから再度お試しください" }];
      } else {
        this.globalErrors = [{ message: err.response.data.message ? err.response.data.message : err.message }];
      }
    }
    clearInterval(this.timerId);
    this.processing = false;
  }
  validationSchema!: yup.AnyObjectSchema;
  beforeCreate() {
    this.validationSchema = yup.object({
      username: yup.string().required(this.$t("input_required", { field: "ユーザーID" })),
      password: yup.string().required(this.$t("input_required", { field: "パスワード" }))
    });
  }
  async onPasswordChanged(values: { username: string; password: string }) {
    const auth = await new AuthApi().login(values);
    Store.getInstance().setAuth(auth.data);
    Router.push(`/clients/${auth.data.clientId}/departments/all/dashboard`);
  }
}
